module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/costume_type_both_costume@2x-93c3d398c80ccce9adbb5c6ac8a921e9.webp";